import { xor } from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';
import { getOrgTermsContent } from '../../../../content/utils.js';
import { RATINGS } from '../../../../lib/schema.js';
import { navigateToProjectReports } from '../../../links/index.jsx';
import RatingLabel from '../../../RatingLabel.jsx';

const IMPACTS = RATINGS.HIGH_MEDIUM_LOW;

ImpactFilter.propTypes = {
  selectedImpacts: PropTypes.arrayOf(PropTypes.oneOf(IMPACTS)),
};

ImpactFilter.defaultProps = {
  selectedImpacts: [],
};

function ImpactFilter({ selectedImpacts }) {
  const selectedCount = selectedImpacts.length;

  const handleSelect = useCallback(
    (impact) =>
      navigateToProjectReports({
        initiativeImpact: impact ? xor(selectedImpacts, [impact]) : [],
      }),
    [selectedImpacts]
  );

  const renderMenuItem = useCallback(
    (impact) => (
      <React.Fragment key={impact}>
        <MenuItem
          active={selectedImpacts.includes(impact)}
          eventKey={impact}
          onSelect={handleSelect}
        >
          <RatingLabel rating={impact} reverse />
        </MenuItem>
      </React.Fragment>
    ),
    [selectedImpacts]
  );

  return (
    <div className="flex-col report-filter">
      <div className="text-muted filter-label">
        {getOrgTermsContent('initiative')} Impact
      </div>
      <ButtonToolbar>
        <DropdownButton
          bsStyle="info"
          title={selectedCount ? `${selectedCount} Selected` : 'All'}
          id="impact-filter"
          className="btn-block"
          onSelect={handleSelect}
          pullRight
        >
          <MenuItem active={selectedCount === 0}>All</MenuItem>
          <MenuItem divider />
          {IMPACTS.map(renderMenuItem)}
        </DropdownButton>
      </ButtonToolbar>
    </div>
  );
}

export default ImpactFilter;
